<div class="card-header" id="checkAnalysisHeader">
    <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse"
        data-target="#checkAnalysisCollapse" aria-expanded="true" aria-controls="checkAnalysisCollapse">
        Vérifications des rapports d'intervention
    </button>
</div>

<div id="checkAnalysisCollapse" class="panel-collapse collapse" aria-labelledby="checkAnalysisHeader"
    data-parent="#accordionExtraction">
    <div class="card-body row">
        <form [formGroup]="form" (ngSubmit)="onSubmit()" class="wrapper shadowed">
            <br>
            <button type="submit" class="btn btn-primary" style="margin-left: 40px;">Valider</button>
        </form>
        <br><br>
        <app-gmao-spinner *ngIf="loading"></app-gmao-spinner>

        <ng-container *ngIf="data">
            <div class="wrapper shadowed">
                <br />
                <h4>Résultats</h4>
                <app-export-button [data]="data"></app-export-button>
                <br />
                <mat-table [dataSource]="data">
                    <ng-container matColumnDef="ok">
                        <mat-header-cell *matHeaderCellDef> OK </mat-header-cell>
                        <mat-cell *matCellDef="let row"> {{row.ok}} </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="nok">
                        <mat-header-cell *matHeaderCellDef> NOK </mat-header-cell>
                        <mat-cell *matCellDef="let row"> {{row.nok}}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="user_login">
                        <mat-header-cell *matHeaderCellDef> Superviseur </mat-header-cell>
                        <mat-cell *matCellDef="let row"> {{row.user_login}}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="mois">
                        <mat-header-cell *matHeaderCellDef> Mois</mat-header-cell>
                        <mat-cell *matCellDef="let row"> {{row.mois}}</mat-cell>
                    </ng-container>
                    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                    <mat-row
                        *matRowDef="let row; columns: ['ok', 'nok', 'user_login', 'mois'] ;">
                    </mat-row>
                </mat-table>
            </div>
        </ng-container>
        <br />
    </div>
</div>